export const CONTACT_FORM_STEPS = {
	CONTACT_FORM: 'contact-form',
	OTP_FORM: 'otp-form',
	SUCCESS_MESSAGE: 'success-message',
	ERROR_MESSAGE: 'submit-error-message'
} as const;

export type ContactFormStep =
	(typeof CONTACT_FORM_STEPS)[keyof typeof CONTACT_FORM_STEPS];

export const STEP_NAMES = {
	[CONTACT_FORM_STEPS.CONTACT_FORM]: 'form modal',
	[CONTACT_FORM_STEPS.OTP_FORM]: '2fa authentication',
	[CONTACT_FORM_STEPS.SUCCESS_MESSAGE]: 'form submitted',
	[CONTACT_FORM_STEPS.ERROR_MESSAGE]: 'error modal'
} as const;

export const LOGIN_METHODS = {
	GOOGLE: 'google',
	FACEBOOK: 'facebook',
	PHONE: 'phone'
} as const;

export type LoginMethod = (typeof LOGIN_METHODS)[keyof typeof LOGIN_METHODS];

export const FORM_SUBMISSION_ACTIONS = {
	SUBMIT: 'submit',
	COMPLETE_PHONE: 'complete_phone',
	COMPLETE_SOCIAL: 'complete_social',
	OTP: 'otp'
} as const;

export type FormSubmissionAction =
	(typeof FORM_SUBMISSION_ACTIONS)[keyof typeof FORM_SUBMISSION_ACTIONS];
